import { Text } from "@fluentui/react/lib/Text";
import { ILinkProps, Link } from "@fluentui/react/lib/Link";

import { isNullOrWhiteSpace } from "Utils/String";

export function OptionalLink(props: ILinkProps): JSX.Element {
  const { children, href } = props;
  if (isNullOrWhiteSpace(href)) {
    return <Text>{children}</Text>;
  }

  return <Link {...props}>{children}</Link>;
}
